export interface NodeData {
  id: string;
  icon?: string;
  appName?: string;
  type?: 'solid' | 'dotted' | 'redEdge' | 'animated' | 'solidNoLink';
  children?: NodeData[];
}

export const PeacockData: NodeData = {
  id: 'SaviyntRoot',
  appName: 'Saviynt',
  children: [
    {
      id: 'ApplicationsJS',
      icon: 'applications',
      children: [
        {
          id: 'ReactCloud',
          icon: 'CloudPlatform',
          type: 'solidNoLink',
          children: [
            { id: 'GitHubIntel', appName: 'Deel', type: 'animated' },
            { id: 'SlackLaunch', appName: 'DocuSign', type: 'dotted' },
            { id: 'DockerMachine', appName: 'Kantata', type: 'solid' },
            { id: 'GitlabRedis', appName: 'Gitlab', type: 'solid' },
          ],
        },
        {
          id: 'VueCollab',
          icon: 'ITHelp',
          type: 'solidNoLink',
          children: [
            {
              id: 'BitbucketPrivileged',
              appName: 'Webex',
              type: 'dotted',
            },
            { id: 'PostgresSaviynt', appName: 'Saviynt', type: 'redEdge' },
            { id: 'SentryGsuit', appName: 'Gsuit', type: 'solid' },
          ],
        },
        {
          id: 'AngularLDAP',
          icon: 'LDAP',
          type: 'solidNoLink',
          children: [
            { id: 'JiraMode', appName: 'Mode', type: 'dotted' },
            { id: 'GraphQLNetsuite', appName: 'Netsuite', type: 'solid' },
            { id: 'LinuxOnelogin', appName: 'Onelogin', type: 'solid' },
          ],
        },
        {
          id: 'NodeSettings',
          icon: 'Settings',
          type: 'solidNoLink',
          children: [
            { id: 'AWSOffice365', appName: 'MSOffice365', type: 'solid' },
            { id: 'FirebaseTenable', appName: 'Tenable', type: 'dotted' },
            { id: 'NginxThycotic', appName: 'Thycotic', type: 'solid' },
            { id: 'MySQLTopSecret', appName: 'TopSecret', type: 'animated' },
          ],
        },
        {
          id: 'PythonDB',
          icon: 'database',
          type: 'solidNoLink',
          children: [
            { id: 'PandasW3', appName: 'W3', type: 'solid' },
            { id: 'TensorFlowSlack', appName: 'Slack', type: 'dotted' },
            { id: 'FastAPIServiceNow', appName: 'ServiceNow', type: 'solid' },
          ],
        },
        {
          id: 'GoEventDriven',
          icon: 'EventDrivenSystem',
          type: 'solidNoLink',
          children: [
            { id: 'GrafanaSalesforce', appName: 'Salesforce', type: 'dotted' },
            { id: 'PrometheusMongo', appName: 'Mongodb', type: 'solid' },
            { id: 'KubernetesWindows', appName: 'Windows', type: 'solid' },
            { id: 'ElasticUnix', appName: 'Unix', type: 'solid' },
          ],
        },
      ],
    },
    {
      id: 'CollaborationJS',
      icon: 'collaboration',
      children: [
        {
          id: 'ReactCloudCollab',
          icon: 'CloudPlatform',
          type: 'solidNoLink',
          children: [
            {
              id: 'GitHubIntelCollab',
              appName: 'Deel',
              type: 'animated',
            },
            {
              id: 'SlackLaunchCollab',
              appName: 'DocuSign',
              type: 'dotted',
            },
            {
              id: 'DockerMachineCollab',
              appName: 'Kantata',
              type: 'solid',
            },
            { id: 'GitlabRedisCollab', appName: 'Gitlab', type: 'solid' },
          ],
        },
        {
          id: 'VueCollabView',
          icon: 'collaboration',
          type: 'solidNoLink',
          children: [
            {
              id: 'BitbucketPrivilegedCollab',
              appName: 'Webex',
              type: 'dotted',
            },
            {
              id: 'PostgresSaviyntCollab',
              appName: 'Saviynt',
              type: 'redEdge',
            },
            { id: 'SentryGsuitCollab', appName: 'Gsuit', type: 'solid' },
          ],
        },
        {
          id: 'AngularLDAPCollab',
          icon: 'LDAP',
          type: 'solidNoLink',
          children: [
            { id: 'JiraModeCollab', appName: 'Mode', type: 'dotted' },
            { id: 'GraphQLNetsuiteCollab', appName: 'Netsuite', type: 'solid' },
            { id: 'LinuxOneloginCollab', appName: 'Onelogin', type: 'solid' },
          ],
        },
        {
          id: 'NodeSettingsCollab',
          icon: 'Settings',
          type: 'solidNoLink',
          children: [
            { id: 'AWSOffice365Collab', appName: 'MSOffice365', type: 'solid' },
            { id: 'FirebaseTenableCollab', appName: 'Tenable', type: 'dotted' },
            { id: 'NginxThycoticCollab', appName: 'Thycotic', type: 'solid' },
            {
              id: 'MySQLTopSecretCollab',
              appName: 'TopSecret',
              type: 'animated',
            },
          ],
        },
        {
          id: 'PythonDBCollab',
          icon: 'database',
          type: 'solidNoLink',
          children: [
            { id: 'PandasW3Collab', appName: 'W3', type: 'solid' },
            { id: 'TensorFlowSlackCollab', appName: 'Slack', type: 'dotted' },
            {
              id: 'FastAPIServiceNowCollab',
              appName: 'ServiceNow',
              type: 'solid',
            },
          ],
        },
        {
          id: 'GoEventDrivenCollab',
          icon: 'EventDrivenSystem',
          type: 'solidNoLink',
          children: [
            {
              id: 'GrafanaSalesforceCollab',
              appName: 'Salesforce',
              type: 'dotted',
            },
            { id: 'PrometheusMongoCollab', appName: 'Mongodb', type: 'solid' },
            {
              id: 'KubernetesWindowsCollab',
              appName: 'Windows',
              type: 'solid',
            },
            { id: 'ElasticUnixCollab', appName: 'Unix', type: 'solid' },
          ],
        },
      ],
    },
    {
      id: 'ManageOverviewJS',
      icon: 'ManageOverview',
      children: [
        {
          id: 'ReactCloudManage',
          icon: 'CloudPlatform',
          type: 'solidNoLink',
          children: [
            {
              id: 'GitHubIntelManage',
              appName: 'Deel',
              type: 'animated',
            },
            {
              id: 'SlackLaunchManage',
              appName: 'DocuSign',
              type: 'dotted',
            },
            {
              id: 'DockerMachineManage',
              appName: 'Kantata',
              type: 'solid',
            },
            { id: 'GitlabRedisManage', appName: 'Gitlab', type: 'solid' },
          ],
        },
        {
          id: 'VueCollabManage',
          icon: 'collaboration',
          type: 'solidNoLink',
          children: [
            {
              id: 'BitbucketPrivilegedManage',
              appName: 'Webex',
              type: 'dotted',
            },
            {
              id: 'PostgresSaviyntManage',
              appName: 'Saviynt',
              type: 'redEdge',
            },
            { id: 'SentryGsuitManage', appName: 'Gsuit', type: 'solid' },
          ],
        },
        {
          id: 'AngularLDAPManage',
          icon: 'LDAP',
          type: 'solidNoLink',
          children: [
            { id: 'JiraModeManage', appName: 'Mode', type: 'dotted' },
            { id: 'GraphQLNetsuiteManage', appName: 'Netsuite', type: 'solid' },
            { id: 'LinuxOneloginManage', appName: 'Onelogin', type: 'solid' },
          ],
        },
        {
          id: 'NodeSettingsManage',
          icon: 'Settings',
          type: 'solidNoLink',
          children: [
            { id: 'AWSOffice365Manage', appName: 'MSOffice365', type: 'solid' },
            { id: 'FirebaseTenableManage', appName: 'Tenable', type: 'dotted' },
            { id: 'NginxThycoticManage', appName: 'Thycotic', type: 'solid' },
            {
              id: 'MySQLTopSecretManage',
              appName: 'TopSecret',
              type: 'animated',
            },
          ],
        },
        {
          id: 'PythonDBManage',
          icon: 'database',
          type: 'solidNoLink',
          children: [
            { id: 'PandasW3Manage', appName: 'W3', type: 'solid' },
            { id: 'TensorFlowSlackManage', appName: 'Slack', type: 'dotted' },
            {
              id: 'FastAPIServiceNowManage',
              appName: 'ServiceNow',
              type: 'solid',
            },
          ],
        },
        {
          id: 'GoEventDrivenManage',
          icon: 'EventDrivenSystem',
          type: 'solidNoLink',
          children: [
            {
              id: 'GrafanaSalesforceManage',
              appName: 'Salesforce',
              type: 'dotted',
            },
            { id: 'PrometheusMongoManage', appName: 'Mongodb', type: 'solid' },
            {
              id: 'KubernetesWindowsManage',
              appName: 'Windows',
              type: 'solid',
            },
            { id: 'ElasticUnixManage', appName: 'Unix', type: 'solid' },
          ],
        },
      ],
    },
  ],
};
